export enum RedirectType {
    RedirectRequested = 'redirectRequested',
    RedirectPerformed = 'redirectPerformed',
}

export interface RedirectRequestedAction {
    type: RedirectType.RedirectRequested;
    url: string;
}

export interface RedirectPerformedAction {
    type: RedirectType.RedirectPerformed;
}

export const redirectRequested = (url: string): RedirectRequestedAction => ({
    type: RedirectType.RedirectRequested,
    url,
});

export const redirectPerformed = (): RedirectPerformedAction => ({
    type: RedirectType.RedirectPerformed,
});

export type RedirectActionTypes = RedirectRequestedAction | RedirectPerformedAction;
